import { Heading, HStack, VStack } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { Skeleton } from "@chakra-ui/skeleton";
import { useTranslations } from "next-intl";
import type { ComponentProps } from "react";

interface ISusbcriptionTypeCard extends ComponentProps<any> {
  title?: string;
  label?: string;
  full_price?: number;
  discount_price?: number;
  isLoading?: boolean;
  isSelected?: boolean;
}

const SusbcriptionTypeCard = ({
  title,
  label,
  full_price,
  discount_price,
  isLoading,
  isSelected,
  onClick,
}: ISusbcriptionTypeCard) => {
  const t = useTranslations("pages.register");
  return (
    <VStack
      align="stretch"
      onClick={onClick}
      px={5}
      py={4}
      border="1px"
      flex="1"
      bg={isSelected ? "brandOrange.100" : "white"}
      borderColor={isSelected ? "brandOrange.200" : "gray.200"}
      cursor="pointer"
      _hover={{ borderColor: "brandOrange.300" }}
    >
      <Skeleton isLoaded={!isLoading}>
        <HStack align="baseline" justify="center">
          {full_price !== discount_price && (
            <Heading
              textAlign="center"
              fontSize="xl"
              textDecorationLine="line-through"
            >
              {full_price}€
            </Heading>
          )}
          <Heading
            textAlign="center"
            fontSize="xl"
            color={isSelected ? "white" : "brandOrange.500"}
          >
            {discount_price && Math.round(discount_price)}€
          </Heading>
        </HStack>
      </Skeleton>
      <VStack spacing={0}>
        <Skeleton isLoaded={!isLoading}>
          <Text
            textAlign="center"
            fontWeight="bold"
            fontSize="lg"
            color={isSelected ? "white" : undefined}
          >
            {title}
          </Text>
        </Skeleton>
        <Skeleton isLoaded={!isLoading}>
          <Text fontSize="xs" color={isSelected ? "white" : "gray.600"}>
            {t("payed")} {label}
          </Text>
        </Skeleton>
      </VStack>
    </VStack>
  );
};

export default SusbcriptionTypeCard;
